import Box from 'components/shared/Box'
import Text from 'components/shared/Text'
import { getDayNameAndDate } from 'helpers/dates'
import { FormattedMessage } from 'react-intl'
import { GetCartItemPresenter } from 'store/api-slice/hooks'
import DiscountedTicketsList from './DiscountedTicketsList'

interface DiscountedTicketsProps {
    dates: string[]
    tickets: GetCartItemPresenter[]
}

const DiscountedTickets = ({ dates, tickets }: DiscountedTicketsProps) => {
    const stayLength = dates.length
    const ticketStartDate = stayLength
        ? `${getDayNameAndDate({
              date: dates[0],
              withYear: true,
          })}`
        : ''
    const ticketEndDate = stayLength
        ? `${getDayNameAndDate({
              date: dates[dates.length - 1],
              withYear: true,
          })}`
        : ''

    return (
        <Box isFullWidth>
            <Box mb={[12, 24]}>
                <Text variant="heading5" color="secondary_500" mb={[16, 12]}>
                    <FormattedMessage
                        id="global.summary.section_caption_tickets"
                        defaultMessage="Bilety do parku"
                    />
                </Text>
                <Text variant="bodySmall" color="grayscale_900">
                    {stayLength > 1
                        ? `${ticketStartDate} - ${ticketEndDate}`
                        : `${ticketStartDate}`}
                </Text>
            </Box>
            <Box gap={[12, 12]} isFullWidth>
                <DiscountedTicketsList tickets={tickets} />
            </Box>
        </Box>
    )
}

export default DiscountedTickets
